module.exports = __webpack_public_path__ + "fonts/Adelle_Bold.b46dea10.woff";